<template>
<div class="chapter">
<div class="inner_page">
<div class="box">
<p class="dedication"><a id="page_v"></a>Oprah Winfrey<br/>You are the epitome of what an<br/>entrepreneur should be.</p>
<p class="dedication1">Thank you for going after what you<br/>want with class and vigor.</p>
<p class="dedication1">You inspire me to reach for greatness<br/>and OWN my choices.</p>
<p class="dedication1">The icing you put of the cake of your<br/>life motivates many to strive to be<br/>stellar.</p>
<p class="dedication1">May all who reads this series be the<br/>cream of the crop too.</p>
<p class="dedication1">You are amazing. I am so grateful for<br/>your example … you shine!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?92bdce4e